import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sidebar-top px-3"
}
const _hoisted_2 = { class: "widget s20 text-black p-4 rounded-40 shadow-200 mb-6 px-7 pt-7 pb-6" }
const _hoisted_3 = { class: "flex align-items-center gap-4 mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "tag-state success ml-4"
}
const _hoisted_5 = {
  key: 1,
  class: "tag-state ml-4"
}
const _hoisted_6 = { class: "secondary-font text-primary-color mb-4" }
const _hoisted_7 = { class: "secondary-font" }
const _hoisted_8 = { class: "app-section" }

import { ref, onMounted } from 'vue'
import SectionSidebar from '@/components/SectionSidebar.vue'
import type { SidebarMenuItem } from '@/components/SectionSidebar.vue'
import carteService, { type Carte } from '@/services/carteService'


export default /*@__PURE__*/_defineComponent({
  __name: 'CarteLayout',
  setup(__props) {

const selectedCarte = ref<Carte | null>(null)

const menuItems: SidebarMenuItem[] = [
  {
    to: '/front/ma-carte',
    icon: '/public/icons/icon-carte.svg',
    label: 'Ma carte',
    exact: true,
    initialSidebarOpen: false
  },
  {
    to: '/front/ma-carte/transactions',
    icon: '/public/icons/icon-transaction.svg',
    label: 'Transactions',
    initialSidebarOpen: true
  },
  {
    to: '/front/ma-carte/repartition',
    icon: '/public/icons/icon-souscription.svg',
    label: 'Répartition',
    initialSidebarOpen: true
  },
  {
    to: '/front/ma-carte/parametres',
    icon: '/public/icons/icon-verrouillage.svg',
    label: 'Paramètres',
    initialSidebarOpen: true
  }
]

onMounted(async () => {
  try {
    const res = await carteService.getCartes()
    if (res.data && Array.isArray(res.data) && res.data.length > 0) {
      selectedCarte.value = res.data.find((c: Carte) => c.parDefaut) || res.data[0]
    }
  } catch (e) {
    // silencieux
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SectionSidebar, { "menu-items": menuItems }, {
      widget: _withCtx(() => [
        (selectedCarte.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[0] || (_cache[0] = _createElementVNode("img", {
                    src: "/public/icons/icon-carte.svg",
                    class: "size-base icon-neutral",
                    alt: ""
                  }, null, -1)),
                  _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "secondary-font" }, "Ma Carte", -1)),
                  (selectedCarte.value.statut === 'active')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Active"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(selectedCarte.value.statut), 1))
                ]),
                _createElementVNode("h6", _hoisted_6, _toDisplayString(selectedCarte.value.alias || selectedCarte.value.type || 'Carte'), 1),
                _createElementVNode("h2", _hoisted_7, _toDisplayString(selectedCarte.value.numeroMasque || ''), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_8, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "page-space-25" }, null, -1)),
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})